module.exports = __webpack_public_path__ + "img/icon-trash.fbec6f18.svg";